import { render } from "./OrdiniInterni.vue?vue&type=template&id=7c917d9c&scoped=true&ts=true"
import script from "./OrdiniInterni.vue?vue&type=script&lang=ts"
export * from "./OrdiniInterni.vue?vue&type=script&lang=ts"

import "./OrdiniInterni.vue?vue&type=style&index=0&id=7c917d9c&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c917d9c"]])

export default __exports__